import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { ISidebarFeatureArea } from "../../../../models/interfaces/sidebar-config.interface";

import "./SidebarFeatureAreaItem.scss";

export const SidebarFeatureAreaItem: FunctionComponent<{
  config: ISidebarFeatureArea;
}> = ({ config }) => {
  const { t } = useTranslation();

  return (
    <div className="sidebar-feature-config-item">
      <div className="sidebar-feature-config-title">{t(config.titleKey)}</div>
      <div className="sidebar-feature-config-content">{!!config.component && <config.component />}</div>
    </div>
  );
};
